export class NewsItem {
    slug;
    title;
    date;
    intro;
    content;
    extraContent;
    thumbnail;
    fullImage;
    isActive;
    anchor;
    backButton;
    newsDetailContainer;
    newsContainer;
    windowSlug;
    urlParams;
    constructor(slug, title, date, intro, content, extraContent, thumbnail, fullImage, isActive = false) {
        this.slug = slug;
        this.title = title;
        this.date = date;
        this.intro = intro;
        this.content = content;
        this.extraContent = extraContent;
        this.thumbnail = thumbnail;
        this.fullImage = fullImage;
        this.isActive = isActive;
        this.windowSlug = window.location.search;
        this.urlParams = new URLSearchParams(this.windowSlug);
        this.newsContainer = document.querySelector('.js-newsoverview');
        this.anchor = document.createElement('a');
        this.anchor.setAttribute('class', 'newsitem');
        this.anchor.setAttribute('href', this.slug);
        this.anchor.addEventListener('click', this.handleClickEvent.bind(this));
        this.newsDetailContainer = document.createElement('div');
        this.backButton = document.createElement('button');
        this.backButton.setAttribute('class', 'newsitem__backbutton button button--underline js-backbutton');
        this.backButton.innerHTML = 'Terug naar overzicht';
        this.backButton.addEventListener('click', this.handleClickEventBack.bind(this));
    }
    renderListView() {
        this.anchor.innerHTML = `
        <div class="newsitem__image-container">
            <div class="newsitem__image">
                <img src="${this.thumbnail}" alt="${this.title}-thumbnail" title="${this.title}-thumbnail">
            </div>
        </div>
        <div class="newsitem__content">
            <div class="newsitem__date">${this.date}</div>
            <h2 class="newsitem__title h4">${this.title}</h2>
            <div class="newsitem__intro">${this.intro}</div>
        </div>
        `;
        return this.anchor;
    }
    renderDetailView() {
        this.newsDetailContainer.innerHTML = `
        <div class="newsitem__top">
            <div class="newsitem__date">${this.date}</div>
            <h1 class="newsitem__title">${this.title}</h1>
            <div class="newsitem__intro">${this.intro}</div>
        </div>
        <div class="newsitem__image-container">
            <div class="newsitem__image newsitem__image--detail">
                <img src="${this.fullImage}" alt="${this.title}-image" title="${this.title}-image">
            </div>
        </div>
        <div class="newsitem__content-detail">
            <div class="newsitem__text">${this.content}</div>
            <div class="newsitem__extra-content">${this.extraContent}</div>
        </div>
        `;
        this.newsDetailContainer.append(this.backButton);
        return this.newsDetailContainer;
    }
    handleClickEvent(e) {
        e.preventDefault();
        let itemSlug = this.slug;
        if (this.windowSlug === '') {
            this.windowSlug += `?news-item=${itemSlug}`;
        }
        else if (this.urlParams.has('news-item')) {
            if (itemSlug === this.urlParams.get('news-item')) {
                return;
            }
            this.urlParams.set('news-item', itemSlug);
            this.windowSlug = this.urlParams;
        }
        else {
            this.windowSlug += `&news-item=${itemSlug}`;
        }
        this.newsContainer.classList.add('fade-out');
        setTimeout(() => {
            window.location.search = this.windowSlug;
        }, 500);
    }
    handleClickEventBack() {
        this.urlParams.delete('news-item');
        this.windowSlug = this.urlParams;
        this.newsContainer.classList.add('fade-out');
        setTimeout(() => {
            window.location.search = this.windowSlug;
        }, 500);
    }
}
export default class NewsOverview {
    windowSlug;
    urlParams;
    newsContainer;
    newsOverviewTitle;
    constructor() {
        this.newsContainer = document.querySelector('.js-newsoverview');
        this.newsOverviewTitle = document.querySelector('.js-newstitle');
        this.windowSlug = window.location.search;
        this.urlParams = new URLSearchParams(this.windowSlug);
        if (!this.newsContainer)
            return;
        let newsItems;
        let urlParams = new URLSearchParams(window.location.search);
        let activeNewsItem;
        fetch(this.newsContainer.dataset.maxusnews)
            .then((response) => response.json())
            .then((data) => {
            newsItems = data.result.map((newsItem) => {
                return new NewsItem(newsItem.slug, newsItem.title, newsItem.publishDate, newsItem.intro, newsItem.content, newsItem.extraContent, newsItem.image['480x270'], newsItem.image['full'], newsItem.slug === urlParams.get('news-item'));
            });
            activeNewsItem = newsItems.filter((item) => item.isActive)[0];
            if (activeNewsItem) {
                this.initNewsItem(activeNewsItem);
                this.newsOverviewTitle.style.display = 'none';
            }
            else {
                this.initNewsOverview(newsItems);
            }
        });
    }
    initNewsOverview(maxusNews) {
        maxusNews.forEach((item) => {
            this.newsContainer.append(item.renderListView());
        });
        this.newsContainer.classList.remove('fade-out');
    }
    initNewsItem(maxusNewsItem) {
        //Build news detail page
        this.newsContainer.append(maxusNewsItem.renderDetailView());
        this.newsContainer.classList.remove('fade-out');
    }
}
